module.exports = __webpack_public_path__ + "media/images/pic/brodno/team/teachers/maria-sarna-c715f49ed5036b4528a2ae444752616f.webp";